"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import JournalPostCard from "./JournalPostCard";
import type { JournalPost } from "./types";
import { useLocaleRouter } from "@/hooks/useLocaleRouter";
import { Title, Text } from "@/components/ui/Headings";

export interface JournalPreviewSectionProps {
  posts: JournalPost[];
}

const JournalPreviewSection: React.FC<JournalPreviewSectionProps> = ({
  posts,
}) => {
  const { t } = useTranslation();
  const { createLocalizedPath } = useLocaleRouter();

  return (
    <section className="py-3 sm:py-5 lg:py-6 hidden md:block">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-4 sm:mb-6 lg:mb-5">
          <Title size="md" className="mb-2 sm:mb-3 lg:mb-2 leading-tight">
            {t("home.journal.heading")}
          </Title>
          <Text
            variant="subtitle"
            className="text-gray-600 max-w-2xl mx-auto px-4 leading-relaxed"
          >
            {t("home.journal.subtitle")}
          </Text>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-3 mb-6 sm:mb-8 lg:mb-10">
          {posts.map((post, index) => (
            <JournalPostCard key={index} post={post} />
          ))}
        </div>
        <div className="text-center">
          <Link
            href={createLocalizedPath("/journal")}
            className="inline-flex items-center text-primary-600 hover:text-primary-700 font-semibold transition-colors text-base"
          >
            {t("home.journal.readMoreButton")}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default JournalPreviewSection;
